var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 12,
    fill: "url(#paint0_linear_43_21)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 134V26.0049C39 25.4507 39.4507 25.0022 40.0049 25.0049L90.25 25.2489C109.286 25.2489 121 36.2414 121 48.8679V113.208C121 127.077 106.664 135 88.2 135H39.9982C39.4459 135 39 134.552 39 134ZM51 122V38C51 37.4477 51.4477 37 52 37H87.25C102.556 37 109 47.5111 109 55.1556V104.844C109 118.669 96.3796 123 87.5185 123H51.9982C51.4459 123 51 122.552 51 122Z",
    fill: "url(#paint1_linear_43_21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5625 41.75V118.75C54.5625 119.302 55.0102 119.75 55.5625 119.75H86.4375C97.0625 119.75 105.562 115.361 105.562 104.844V56.55C105.562 47.7722 98.9514 40.75 86.4375 40.75H55.5625C55.0102 40.75 54.5625 41.1977 54.5625 41.75ZM66.5625 54V107C66.5625 107.552 67.0102 108 67.5625 108H83.4375C89.0625 108 93.5625 104.944 93.5625 97.6226V80.8113V64C93.5625 57.8889 90.0625 53 83.4375 53H67.5625C67.0102 53 66.5625 53.4477 66.5625 54Z",
    fill: "url(#paint2_linear_43_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_21",
    x1: 160,
    y1: 160,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.100962,
    stopColor: "#01043B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222127,
    stopColor: "#22244B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#24275B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70332,
    stopColor: "#22244B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927963,
    stopColor: "#01043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_21",
    x1: 121.37,
    y1: 12.7323,
    x2: 24.0056,
    y2: 154.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75716,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43_21",
    x1: 98.5,
    y1: 35,
    x2: 28.5,
    y2: 163.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119884,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788462,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913462,
    stopColor: "#D7D7D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf5e7501390b9c2fa15996b9103644a2.svg";
export { ForwardRef as ReactComponent };